module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"signin_title":"Login","signin_submit":"Login","signin_google":"Login mit Google","signin_azure":"Login mit Azure","signin_reset_password":"Passwort zurücksetzen"},"en":{"signin_title":"Sign In","signin_submit":"Sign In","signin_google":"Sign in with Google","signin_azure":"Sign in with Azure","signin_reset_password":"Reset Password"}}')
  delete Component.options._Ctor
}
